import {
  Box,
  Flex,
  Button,
  Heading,
  Text,
  theme,
  Loader,
} from "@singita/components"
import React, { useEffect, useRef, useState } from "react"
import { useSubmitForm } from "../../Forms/hooks/useSubmitForm"
import { FORM_STATUS } from "../../Forms/common/constants"
import { getIpAddress } from "../../Forms/services/ipAddress"
import { Translation } from "react-i18next"

const loadBlackBaud = callback => {
  const existingScript = document.getElementById("loadBlackBaud")
  if (!existingScript) {
    const script = document.createElement("script")
    script.src = "https://payments.blackbaud.com/Checkout/bbCheckout.2.0.js"
    script.id = "loadBlackBaud"
    document.body.appendChild(script)
    script.onload = () => {
      if (callback) callback()
    }
  }
  if (existingScript && callback) callback()
}

const Confirmation = ({
  onError,
  onSetValues,
  campaignId,
  fundId,
  emailId,
  values,
  error = "",
}) => {
  const [errors, setErrors] = useState({})
  const [submitLoader, setSubmitLoader] = useState(false)
  const [submitForm, apiLoading, status, changeStatus] = useSubmitForm(
    "donation"
  )

  const form = useRef()

  const onSubmit = async () => {
    try {
      setSubmitLoader(true)
      changeStatus(FORM_STATUS.PENDING)
      const ip = await getIpAddress()
      const data = await submitForm({
        variables: {
          input: {
            form: "donation",
            fields: {
              ...values,
              ip_address: ip,
            },
          },
        },
      })
      const response = data?.data?.submitTransactionWebsiteForm

      if (!response) {
        throw new Error("Failed to submit form")
      }

      if (!response.recaptchaSuccess) {
        if (response.requiresChallenge) {
          setErrors({
            ...errors,
            recaptcha:
              "Your request has been flagged as potentially suspicious. Please try again later.",
          })
          changeStatus(FORM_STATUS.FAILED)
          setSubmitLoader(false)
          return null
        }
      }
      setSubmitLoader(false)
      changeStatus(FORM_STATUS.SUCCESS)
    } catch (error) {
      setErrors({
        ...errors,
        ["form.form-failed"]: "Could not submit form.Please contact support.",
      })
      console.error("Form submission error:", error)
      changeStatus(FORM_STATUS.FAILED)
      setSubmitLoader(false)
    }
    const transactionData = {
      billing_address_post_code: values.postalCode,
      billing_address_first_name: values.name,
      billing_address_last_name: values.surname,
      billing_address_line: values.address,
      billing_address_city: values.city,
      billing_address_state: values.state,
      billing_address_country: values.country,
      billing_address_phone: values.phone,
      billing_address_email: values.email,
      Key: "b792858d-7598-4564-a859-21d038519f8c",
      MerchantAccountId: "6f7b4e8d-67e5-4579-a283-706ba0ad86a1",
      UseCaptcha: true,
      Amount: values.amount,
      ClientAppName: "eTapestry DIY",
      SourceCode: 0,
      UseVisaCheckout: true,
      UseApplePay: true,
      UsePayPal: true,
      ClientDomain: "singita.com",
      PrimaryColor: "",
      SecondaryColor: "",
      FontColor: "",
      FontFamily: "",
      UseApplePayDonateButton: false,
    }

    // call the Checkout method to display the payment form
    window.Blackbaud_OpenPaymentForm(transactionData)
  }

  const handleComplete = e => {
    onError(null)
    onSetValues({
      token: e.detail.transactionToken,
    })

    setTimeout(() => {
      form.current.submit()
    }, 1000)
  }
  useEffect(() => {
    loadBlackBaud()

    document.addEventListener("checkoutCancel", function () {
      onError("Transaction Cancelled")
    })

    document.addEventListener("checkoutComplete", handleComplete)

    document.addEventListener("checkoutError", function (e) {
      onError(e.detail.errorText)
    })

    return () => {
      document.removeEventListener("checkoutComplete", handleComplete)
      document.removeEventListener("checkoutCancel", function () {
        onError("Transaction Cancelled")
      })
      document.removeEventListener("checkoutError", function (e) {
        onError(e.detail.errorText)
      })
    }
  }, [])

  const isLoading = submitLoader || apiLoading

  return (
    <div className="maps-component">
      <Heading variant="primary" mb={[1, 3]}>
        Donation Details
      </Heading>
      {error ? (
        <Box p={[2]} mb={[2]} bg={theme.colors.statusError}>
          <Text color={theme.colors.baseWhite}>{error}</Text>
        </Box>
      ) : null}
      <Box>
        <Box mb={[2]}>
          <Text fontWeight="bold" size="small">
            Title:{" "}
          </Text>
          <Text fontWeight="bold" size="small">
            {values.title}
          </Text>
        </Box>
        <Box mb={[2]}>
          <Text fontWeight="bold" size="small">
            Name:{" "}
          </Text>
          <Text fontWeight="bold" size="small">
            {values.name}
          </Text>
        </Box>
        <Box mb={[2]}>
          <Text fontWeight="bold" size="small">
            Surname:{" "}
          </Text>
          <Text fontWeight="bold" size="small">
            {values.surname}
          </Text>
        </Box>
        <Box mb={[2]}>
          <Text fontWeight="bold" size="small">
            Amount:{" "}
          </Text>
          <Text fontWeight="bold" size="small">
            ${values.amount}
          </Text>
        </Box>
        <Box mb={[2]}>
          <Text fontWeight="bold" size="small">
            Email:{" "}
          </Text>
          <Text fontWeight="bold" size="small">
            {values.email}
          </Text>
        </Box>
      </Box>
      <form
        method="post"
        name="donorForm"
        ref={form}
        action="https://sna.etapestry.com/prod/HostedOnlineDonorRegSave.jsp"
      >
        <input
          type="hidden"
          name="dbOrgName"
          value="FriendsofthePeaceParksInc"
        />
        <input type="hidden" name="locale" value="en_US" />
        <input type="hidden" name="isDiy" value="true" />
        <input type="hidden" name="isNewAddress" value="true" />
        <input type="hidden" name="pageId" value="PdMEZzdN" />
        <input
          type="hidden"
          name="successURL"
          value="https://singita.com/donation-success/"
        />
        <input
          type="hidden"
          name="failURL"
          value="https://singita.com/donation-error/"
        />
        <input type="hidden" name="persona" value="Personal" />
        <input type="hidden" name="generateReceipt" value="false" />
        <input type="hidden" name="notifyDonor" value="true" />
        <input type="hidden" name="fromEMail" value="traveller@singita.com" />
        <input type="hidden" name="notifyOrg" value="true" />
        <input
          type="hidden"
          name="notifyEMail"
          value="brady@africanccf.org,pete@africanccf.org,alex@africanccf.org,adrian.k@singita.com"
        />
        <input type="hidden" name="transType" value="donation" />
        <input
          type="hidden"
          name="bbpsPublicKey"
          value="b792858d-7598-4564-a859-21d038519f8c"
        />
        <input
          type="hidden"
          name="bbpsMerchantId"
          value="6f7b4e8d-67e5-4579-a283-706ba0ad86a1"
        />
        <input type="hidden" name="bbpsPaymentToken" value={values.token} />
        <input type="hidden" name="bbpsCheckoutRequired" value="true" />
        <input type="hidden" name="allow" value="true" />
        <input type="hidden" name="accountName" />
        <input type="hidden" name="sortName" />
        <input type="hidden" name="longSalutation" />
        <input type="hidden" name="shortSalutation" />
        <input type="hidden" name="personaNote" />
        <input type="hidden" name="rgsCreate" value="true" />
        <input type="hidden" name="rgsCopyUDFs" value="true" />
        <input type="hidden" name="approachName" value="10557.0.143395913" />
        <input type="hidden" name="campaignName" value={campaignId} />
        <input
          type="hidden"
          name="transProcessorRefName"
          value="10557.0.246867"
        />
        <input type="hidden" name="letterName" value="" />
        <input
          type="hidden"
          name="donorEmailSubject"
          value="Thank you for your donation, in support of this worthy program."
        />
        <input
          type="hidden"
          name="orgEmailSubject"
          value="Donation Confirmation Email"
        />
        <input type="hidden" name="donorEmailRef" value={emailId} />
        <input type="hidden" name="orgLocale" value="en_US" />
        <input type="hidden" name="fundName" value={fundId} />
        <input type="hidden" name="donationAmt" value={"otherAmt"} />
        <input type="hidden" name="otherAmt" value={values.amount} />
        <input type="hidden" name="suffix" value={"5889690"} />
        <input
          type="hidden"
          name="eCommercePageName"
          value={"https://singita.com/donations/"}
        />
        <input type="hidden" name="amount" value={values.amount} />
        <input type="hidden" name="salutation" value={values.title} />
        <input type="hidden" name="salutationGender" value={""} />
        <input type="hidden" name="firstName" value={values.name} />
        <input type="hidden" name="middleName" value={""} />
        <input type="hidden" name="lastName" value={values.surname} />
        <input type="hidden" name="country" value={values.country} />
        <input type="hidden" name="city" value={values.city} />
        <input type="hidden" name="state" value={values.state} />
        <input type="hidden" name="county" value={values.state} />
        <input type="hidden" name="address" value={values.address} />
        <input type="hidden" name="postalCode" value={values.postalCode} />
        <input type="hidden" name="confirmEmail" value={values.email} />
        <input type="hidden" name="email" value={values.email} />
        <input type="hidden" name="phone" value={values.phone} />
        <input type="hidden" name="rgsFrequency" value={"-"} />
        <input
          type="hidden"
          name="Customer_SetElement|10557.0.178623533|10557.0.178623535"
          value={values.newsletter || false}
        />
        <input
          type="hidden"
          name="Customer_SetElement|10557.0.178607152|10557.0.178607154"
          value={values.accf || false}
        />
        <input
          type="hidden"
          name="Customer_SetElement|10557.0.178621481|10557.0.178621483"
          value={values.consent || false}
        />
        <input
          type="hidden"
          name="JournalEntry_TextField|43.0.14637203"
          value={values.notes || ""}
        />
      </form>

      <Flex alignItems="center" justifyContent="center">
        {isLoading ? (
          <Loader isActive size={100} />
        ) : (
          <Button variant="primary" onClick={onSubmit}>
            Confirm
          </Button>
        )}
      </Flex>
      {Object.keys(errors).map(errorKey => (
        <Flex key={errorKey} alignItems="center" justifyContent="center">
          <Box mt={[1]}>
            <Text color="statusError" size="small">
              <Translation>{t => t(errorKey) ?? errors[errorKey]}</Translation>
            </Text>
          </Box>
        </Flex>
      ))}
    </div>
  )
}

export default Confirmation
